module.exports = __webpack_public_path__ + "img/logo.612fcaf4.png";